export class PrimaryGoalModal{
    primayr_goal_intention:string;
}


// WEBPACK FOOTER //
// ./src/pages/adf-page/component/primary-applicant/primary-goal/primary-goal.model.ts